<template>
  <div class="wrap">
    <div class="message">Выберите, кому бы хотели написать</div>
  </div>
</template>

<script>
export default {
name: "chat_dont_chosed"
}
</script>

<style scoped lang="scss">
.wrap {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
